import LocalSeoPage from '@/pages/local/components/LocalSeoPage';
import { aracruzHidraulica } from '@/mocks/localSeoData';

export default function HidraulicaIndustrialAracruz() {
  return <LocalSeoPage data={aracruzHidraulica} />;
}